import { createContext, type ReactNode, useContext } from 'react'
import type { DocumentProcessingPipelinePhase } from '@/types/documentProcessingPipeline'

const ProcessingPipelinePhaseContext = createContext<
	ReadonlyMap<string, DocumentProcessingPipelinePhase>
>(new Map())

export function ProcessingPipelinePhaseProvider({
	value,
	children,
}: {
	value: ReadonlyMap<string, DocumentProcessingPipelinePhase>
	children: ReactNode
}) {
	return (
		<ProcessingPipelinePhaseContext.Provider value={value}>
			{children}
		</ProcessingPipelinePhaseContext.Provider>
	)
}

export function useProcessingPipelinePhase(
	artifactId: string
): DocumentProcessingPipelinePhase | undefined {
	return useContext(ProcessingPipelinePhaseContext).get(artifactId)
}
